import { PolicyChangeForm } from './PolicyChangeForm'
import { PolicyChangesGate } from './PolicyChangesGate'

export function NewPolicyChange() {
  return (
    <PolicyChangesGate>
      <PolicyChangeForm />
    </PolicyChangesGate>
  )
}
